import { __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { useLocalization } from '@shared-ui/localization-context';
import styles from '../../uitk-calendar.css';
import { UitkDateNumberThemes, UitkTypeSizes, UitkTypeWeights } from '../../types.esm.js';

var getClassNameList = classNames.bind(styles);
/**
 * This is where the description of Date Number will go.
 */
var UitkDateNumber = function (props) {
    var _a = props.theme, theme = _a === void 0 ? 'default' : _a, _b = props.size, size = _b === void 0 ? 300 : _b, _c = props.weight, weight = _c === void 0 ? 'regular' : _c, _d = props.disabled, disabled = _d === void 0 ? false : _d, children = props.children;
    var wrapperClassNames = getClassNameList('uitk-date-number', UitkDateNumberThemes.get(theme), UitkTypeSizes.get(size), UitkTypeWeights.get(weight), { 'is-disabled': disabled });
    var l10n = useLocalization();
    var ariaLabel = theme === 'today' ? l10n.formatText('calendar.today.a11yLabel') : null;
    return (React.createElement("div", __assign({ className: wrapperClassNames, "aria-hidden": !ariaLabel }, (ariaLabel && { 'aria-label': ariaLabel })), children));
};
UitkDateNumber.displayName = 'UitkDateNumber';

export { UitkDateNumber };
